import api from '../../api/axios';

export const CALL_AGENT_NUMBERS_REQUEST = 'CALL_AGENT_NUMBERS_REQUEST';
export const CALL_AGENT_NUMBERS_SUCCESS = 'CALL_AGENT_NUMBERS_SUCCESS';
export const CALL_AGENT_NUMBERS_FAILURE = 'CALL_AGENT_NUMBERS_FAILURE';
export const CALL_AGENT_PURCHASE_REQUEST = 'CALL_AGENT_PURCHASE_REQUEST';
export const CALL_AGENT_PURCHASE_SUCCESS = 'CALL_AGENT_PURCHASE_SUCCESS';
export const CALL_AGENT_PURCHASE_FAILURE = 'CALL_AGENT_PURCHASE_FAILURE';
export const CALL_AGENT_CANCEL_PLAN_REQUEST = 'CALL_AGENT_CANCEL_PLAN_REQUEST';
export const CALL_AGENT_CANCEL_PLAN_SUCCESS = 'CALL_AGENT_CANCEL_PLAN_SUCCESS';
export const CALL_AGENT_CANCEL_PLAN_FAILURE = 'CALL_AGENT_CANCEL_PLAN_FAILURE';
export const FETCH_CURRENT_SUBSCRIPTION_REQUEST = 'FETCH_CURRENT_SUBSCRIPTION_REQUEST';
export const FETCH_CURRENT_SUBSCRIPTION_SUCCESS = 'FETCH_CURRENT_SUBSCRIPTION_SUCCESS';
export const FETCH_CURRENT_SUBSCRIPTION_FAILURE = 'FETCH_CURRENT_SUBSCRIPTION_FAILURE';
export const FETCH_PLANS_REQUEST = 'FETCH_PLANS_REQUEST';
export const FETCH_PLANS_SUCCESS = 'FETCH_PLANS_SUCCESS';
export const FETCH_PLANS_FAILURE = 'FETCH_PLANS_FAILURE';

export const fetchAvailablePhoneNumbers = (page = 1, limit = 25, append = false, filters = {}) => async (dispatch) => {
  dispatch({ type: CALL_AGENT_NUMBERS_REQUEST, append });
  try {
    const params = { page, limit };
    
    // Add filters to params
    if (filters.state) {
      params.state = filters.state;
    }
    if (filters.contains) {
      params.contains = filters.contains;
    }
    
    const response = await api.get(`voiceAgent/getAvailablePhoneNumbers`, {
      params,
    });
    const { data } = response;
    const items = data?.data || [];
    dispatch({
      type: CALL_AGENT_NUMBERS_SUCCESS,
      payload: {
        items,
        page: data?.page ?? page,
        limit: data?.limit ?? limit,
        total: data?.total ?? (items.length || 0),
      },
      append,
    });
    return items;
  } catch (error) {
    dispatch({
      type: CALL_AGENT_NUMBERS_FAILURE,
      error: error?.response?.data?.message || error?.message || 'Failed to load phone numbers',
    });
    return [];
  }
};

export const purchasePhoneNumber = (phoneNumber) => async (dispatch) => {
  dispatch({ type: CALL_AGENT_PURCHASE_REQUEST });
  try {
    const res = await api.post('voiceAgent/purchasePhoneNumber', { phoneNumber });
    const ok = !!(res?.data?.success);
    if (!ok) throw new Error(res?.data?.message || 'Failed to purchase number');
    dispatch({ type: CALL_AGENT_PURCHASE_SUCCESS, payload: { phoneNumber } });
    return { success: true, message: res?.data?.message };
  } catch (error) {
    const message = error?.response?.data?.message || error?.message || 'Failed to purchase number';
    dispatch({ type: CALL_AGENT_PURCHASE_FAILURE, error: message });
    return { success: false, error: message };
  }
};

export const cancelPlan = (planId) => async (dispatch) => {
  dispatch({ type: CALL_AGENT_CANCEL_PLAN_REQUEST });
  try {
    const res = await api.put(`/subscriptions/${planId}/cancel`, {
      cancelAtPeriodEnd: true
    });
    const ok = !!(res?.data?.success);
    if (!ok) throw new Error(res?.data?.message || 'Failed to cancel plan');
    dispatch({ type: CALL_AGENT_CANCEL_PLAN_SUCCESS });
    return { success: true, message: res?.data?.message };
  } catch (error) {
    const message = error?.response?.data?.message || error?.message || 'Failed to cancel plan';
    dispatch({ type: CALL_AGENT_CANCEL_PLAN_FAILURE, error: message });
    return { success: false, error: message };
  }
};

export const fetchCurrentSubscription = () => async (dispatch) => {
  dispatch({ type: FETCH_CURRENT_SUBSCRIPTION_REQUEST });
  try {
    const response = await api.get('/subscriptions/current');
    
    if (response?.data?.success) {
      const subscription = response.data.data.subscription;
      dispatch({
        type: FETCH_CURRENT_SUBSCRIPTION_SUCCESS,
        payload: subscription
      });
      return { success: true, data: subscription };
    } else {
      // No subscription found
      dispatch({
        type: FETCH_CURRENT_SUBSCRIPTION_SUCCESS,
        payload: null
      });
      return { success: true, data: null };
    }
  } catch (error) {
    // Treat error as no subscription
    dispatch({
      type: FETCH_CURRENT_SUBSCRIPTION_FAILURE,
      error: error?.response?.data?.message || error?.message || 'Failed to fetch subscription'
    });
    return { success: false, error: error?.response?.data?.message || 'Failed to fetch subscription' };
  }
};

export const fetchPlans = () => async (dispatch) => {
  dispatch({ type: FETCH_PLANS_REQUEST });
  try {
    const response = await api.get('/subscriptions/plans');
    
    if (response?.data?.success) {
      dispatch({
        type: FETCH_PLANS_SUCCESS,
        payload: response.data.data || []
      });
      return { success: true, data: response.data.data };
    } else {
      throw new Error(response?.data?.message || 'Failed to fetch plans');
    }
  } catch (error) {
    const errorMessage = error?.response?.data?.message || error?.message || 'Failed to load subscription plans';
    dispatch({
      type: FETCH_PLANS_FAILURE,
      error: errorMessage
    });
    return { success: false, error: errorMessage };
  }
};


